import { Box } from '@mui/material'
import moment from 'moment'
import { ReactComponent as RequestDetails } from '../../../../images/RequestDetails.svg'
import { decodeHtmlString, getFormattedDateHours } from '../../../../utils/helpers'
import CookiesStorageService from '../../../../services/CookiesStorageService'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import TitleWithInfo from '../../../../components/Cards/helpers/TitleWithInfo'
import UseTranslation from '../../../../hooks/UseTranslation'
import AttachmentDownloader from '../../../../components/Cards/helpers/AttachmentDownloader'

const OverTimeDetailsRequest = ({ details, showTitle }) => {
  const { t } = UseTranslation()

  function formatPeriod(timeString) {
    if (!timeString) return '';

    const isArabic = CookiesStorageService.getUserLanguage() === 'AR';
    const time = moment(timeString, 'HH:mm').format(isArabic ? 'H [س] m [د]' : 'H[h] m[m]');

    return time;
  }

  const getFormattedDateDashedWithoutHours = (date) => moment(date)?.format('dddd - D MMMM YYYY')

  return (
    <Box sx={styles.detailsContainer(showTitle)}>
      {showTitle && (
      <TitleWithIcon
        title={t?.['Request Details']}
        icon={<RequestDetails />}
        customStyle={styles.stackFlex}
        textVariant="heading4"
        iconSize="sm"
      />
      )}
      <Box sx={styles.detailsBox(showTitle)}>
        <Box sx={styles.detailsData}>

          <TitleWithInfo
            title={`${t?.['Request Type']}`}
            info={details?.type?.name}
            customStyle={styles.detailsInfo}
          />

          <TitleWithInfo
            title={`${t?.['Overtime Date']}`}
            info={getFormattedDateDashedWithoutHours(details?.source?.requestDate)}
            customStyle={styles.detailsInfo}
          />
          <TitleWithInfo
            title={`${t?.['Start Time']}`}
            info={details?.source?.startTime ? getFormattedDateHours(details?.source?.startTime) : '- - -'}
            customStyle={styles.detailsInfo}
          />

          <TitleWithInfo
            title={`${t?.['End Time']}`}
            info={details?.source?.endTime ? getFormattedDateHours(details?.source?.endTime) : '- - -'}
            customStyle={styles.detailsInfo}
          />

          <TitleWithInfo
            title={`${t?.Period}`}
            info={formatPeriod(details?.source?.period)}
            customStyle={styles.detailsInfo}
          />
 {details?.attachment_group_id && (
          <TitleWithInfo
            title={`${t?.Attachments}`}
            info={(
              <AttachmentDownloader
                attachments={details?.attachment_group_id}
              />
              )}
            customStyle={styles.detailsInfo}
          />
 )}
        </Box>
        <TitleWithInfo
          title={`${t?.Comment}`}
          info={decodeHtmlString(details?.source?.comment || '-- -- --')}
          customStyle={styles.commentInfo}
        />
      </Box>
    </Box>

  )
}

export const styles = {
  detailsContainer: (showTitle) => ({
    padding: showTitle ? { xs: '10px 0px', sm: '20px' } : { xs: '0px', sm: '0px 20px' },
  }),
  stackFlex: {
    display: 'flex',
    alignItems: 'center',
    fontSize: { xs: '14px', sm: '18px' },
    gap: '10px',
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      marginLeft: '0px',
    },
  },
  detailsBox: (showTitle) => ({
    p: showTitle ? { xs: '10px 0', md: '20px 20px 0px' } : { xs: '0px', md: '0px 20px' },
  }),

  detailsData: {

    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
    gridAutoFlow: 'row',
    columnGap: '50px',
  },
  DataInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  detailsInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    my: '10px',
    h5: {
      margin: '0px',
      maxWidth: { xs: '140px', md: '200px' },
      fontWeight: 350,
      fontSize: { xs: '13px', md: '14px' },
      lineHeight: { xs: '22px', md: '27.9px' },
      color: '#92929D',
    },
    h6: {
      maxWidth: { xs: '100%', md: '280px' },
      margin: '0px',
      fontWeight: 350,
      fontSize: { xs: '14px', md: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
    },
  },
  commentInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    my: { xs: '10px', md: '10px' },
    h5: {
      margin: '0px',
      width: '20%',
      maxWidth: { xs: '140px', md: '200px' },
      fontWeight: 350,
      fontSize: { xs: '13px', md: '14px' },
      lineHeight: { xs: '22px', md: '27.9px' },
      color: '#92929D',
    },
    h6: {
      width: '80%',
      maxWidth: { xs: '180px', md: 'unset' },
      margin: '0px',
      fontWeight: 350,
      textAlign: { xs: 'right', md: 'left' },
      fontSize: { xs: '14px', md: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
      '& p': {
        margin: '0px',

      },
    },
  },
}

export default OverTimeDetailsRequest
